import { useAppSelector } from "@/redux/store";
import { isProdataPortal } from "@/shared/lib/utils";

export default function AppFooter() {
	const whitelabel = useAppSelector(state => state.whitelabelConfigs);

	if (!isProdataPortal()) return null;

	return (
		<div className="text-muted-foreground fixed bottom-0 z-50 w-full bg-white shadow-lg">
			<div className="flex flex-col items-center p-4 md:flex-row">
				<p className="text-center text-xs md:text-left">&copy; {whitelabel.company_name}. All Rights Reserved.&nbsp;</p>
				<div className="mt-2 flex items-center justify-center text-xs md:mt-0 md:justify-start">
					<a
						href="/terms-conditions"
						target="_blank"
						rel="noopener noreferrer"
						className="hover:text-[#004F8D] hover:underline"
					>
						Terms & Conditions
					</a>
					<span className="px-1">
						{"  "}and{"  "}
					</span>
					<a
						href="/privacy-policy"
						target="_blank"
						rel="noopener noreferrer"
						className="hover:text-[#004F8D] hover:underline"
					>
						Privacy
					</a>
				</div>
			</div>
		</div>
	);
}
